import axios from "axios";

const getPriceTRY = async (currencies) => {
    const res = await axios.get('https://api.exchangerate-api.com/v4/latest/TRY')
    const currencyRates = res.data
    const values = []
    for (const currency of currencies) {
        values.push({
            currency,
            value: parseFloat((1/currencyRates.rates[currency]).toPrecision(5))
        })
    }

    return values
}

const CurrencyService = {
    getPriceTRY
}

export default CurrencyService